import React, {useEffect} from 'react';
import NavigationBar from '../components/NavigationBar';
import Footer from '../components/Footer';
import Head from "../components/Head";

function AboutUs() {
  // Animation effect for form elements
  useEffect(() => {
    const animateFormElements = () => {
      const elements = document.querySelectorAll('.animate-in');

      elements.forEach((element, index) => {
        setTimeout(() => {
          element.classList.add('show');
        }, 100 * index);
      });
    };

    // Run animation after a short delay
    setTimeout(animateFormElements, 200);
  }, []);

  return (
      <>
        <Head pageTitle="AMR - About Us" />
        <NavigationBar/>

        <style jsx="true">{`
          /* Animation styles */
          .animate-in {
            opacity: 0;
            transform: translateY(20px);
            transition: opacity 0.5s ease, transform 0.5s ease;
          }

          .animate-in.show {
            opacity: 1;
            transform: translateY(0);
          }
        `}</style>

        <main className="about-page">
          <section id="about-1" className="py-5 first-section animate-in">
            <div className="container">
              <div className="row gy-lg-5 align-items-center">
                <div className="col-lg-6 order-lg-1 text-center text-lg-start">
                  <div className="title pt-3 pb-5">
                    <h2 id={"pageTitle"} className="position-relative d-inline-block ms-4">About Us</h2>
                  </div>
                  <p className="lead text-muted">
                    An idea that started within the family, to a reality that has now reached many.
                  </p>
                </div>
                <div className="col-lg-6 order-lg-0">
                  <img
                      src="/images/team-spirit-2447163_1280.jpg"
                      alt="Team holding each others arms."
                      className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </section>

          <section id="about-2" className="py-5 animate-in">
            <div className="container">
              <div className="row gy-lg-5 align-items-center">
                <div className="col-lg-6 order-lg-1 text-center text-lg-start">
                  <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d49766.91123156809!2d-77.17671905!3d38.77673095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89b64de885e53a9d%3A0x67e76f2416faa504!2sSpringfield%2C%20VA!5e0!3m2!1sen!2sus!4v1726326974623!5m2!1sen!2sus"
                      width="600"
                      height="450"
                      style={{border: 0}}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Springfield Map"
                  ></iframe>
                </div>
                <div className="col-lg-6 order-lg-0">
                  <p className="lead text-muted">This is where it all started!</p>
                  <p>AMR was founded in Springfield, VA, the home to our idea and success.</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        <Footer/>
      </>
  );
}

export default AboutUs;
